module.exports = __webpack_public_path__ + "static/media/Employer_4.9cb6e25b.svg";